class InsightsLineCell extends UITableViewCell
{
    private messageLabel:MUILabel = null;

    awakeFromHTML(){
        this.messageLabel = MUIOutlet(this, "message-lbl", "MUILabel");
    }

    set item(item:any){
        this.messageLabel.text = item["message"];
    }
}